/** XeAgents.ai - Enterprise Billing Settings */
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Percent, RefreshCw, TrendingUp, CreditCard, Building2 } from "lucide-react";
import TaxRateManagement from "./TaxRateManagement";
import DunningConfigManagement from "./DunningConfigManagement";
import RevenueRecognitionDashboard from "./RevenueRecognitionDashboard";

export default function EnterpriseBillingSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Enterprise Billing</h2>
        <p className="text-muted-foreground">
          Configure tax rates, dunning policies, and revenue recognition settings.
        </p>
      </div>

      <Tabs defaultValue="tax" className="space-y-4">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:inline-grid">
          <TabsTrigger value="tax" className="gap-2">
            <Percent className="h-4 w-4" />
            <span className="hidden sm:inline">Tax Rates</span>
            <span className="sm:hidden">Tax</span>
          </TabsTrigger>
          <TabsTrigger value="dunning" className="gap-2">
            <RefreshCw className="h-4 w-4" />
            <span className="hidden sm:inline">Dunning</span>
            <span className="sm:hidden">Retry</span>
          </TabsTrigger>
          <TabsTrigger value="revenue" className="gap-2">
            <TrendingUp className="h-4 w-4" />
            <span className="hidden sm:inline">Revenue Recognition</span>
            <span className="sm:hidden">Revenue</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="tax">
          <TaxRateManagement />
        </TabsContent>

        <TabsContent value="dunning">
          <DunningConfigManagement />
        </TabsContent>

        <TabsContent value="revenue">
          <RevenueRecognitionDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
